module.exports = __webpack_public_path__ + "img/level_five.2b2c69f0.png";